import Util from 'utils';
// 常用枚举值
// 卡类型
export const cardTypeMap = {
  '-1': '优惠顾客',
  0: '普卡',
  1: '银卡',
  2: '金卡',
  3: '钻卡',
  10: 'VIP'
};

// 证件类型
export const certTypeList = [
  { label: '身份证', value: 1 },
  { label: '护照', value: 2 },
  { label: '港澳台证', value: 3 },
  { label: '其它证件', value: 4 }
];

export const canvasElementType = {
  IMAGE: 'image',
  TEXT: 'text',
  VIEW: 'view'
};

export const belongAreaList = [
  { label: 'A区', value: 1 },
  { label: 'B区', value: 2 }
];

export const THbelongAreaList = [
  { label: '左', value: 1 },
  { label: '右', value: 2 }
];

// 性别
export const genderList = [
  { label: '男', value: '0' },
  { label: '女', value: '1' }
];

// 学历
export const educationList = [
  { label: '本科及以上', value: '0' },
  { label: '大专', value: '1' },
  { label: '高中/中专', value: '2' },
  { label: '初中及以下', value: '3' }
  // { label: '其他', value: '4' },
];

// 职业
export const jobList = [
  { label: '企事业管理人员', value: '0' },
  { label: '专业人士', value: '1' },
  { label: '私营老板', value: '2' },
  { label: '职员/职工', value: '3' },
  { label: '自由职业', value: '4' },
  { label: '下岗/退休', value: '5' },
  { label: '务农', value: '6' },
  { label: '其他', value: '7' }
];

// 婚姻状态（0为已婚、1为未婚、2为离异）
export const maritalStatusList = [
  {
    value: 0,
    label: '未婚'
  },
  {
    value: 1,
    label: '已婚'
  },
  {
    value: 2,
    label: '丧偶'
  },
  {
    value: 3,
    label: '离异'
  },
  {
    value: 4,
    label: '未知'
  }
];

// 会员等级（0正式会员，1业务主任，2销售主任，3高级销售主任，4.销售经理（1星）5.初级销售经理（2星）6.中级销售经理（3星）7.高级销售经理（4星）8.资深销售经理（5星）9.销售总监，10.执行销售总监，11.行政销售总监，12.首席销售经理，13.董事销售经理）
const levelStr =
  '无级别、业务主任、销售主任、高级销售主任、销售经理、初级销售经理、中级销售经理、高级销售经理、资深销售经理、销售总监、执行销售总监、行政销售总监、首席销售经理、董事销售经理';
let temLevelList = levelStr.split('、');
export const levelList = temLevelList.map((item, index) => {
  return {
    value: index - 1,
    label: item
  };
});

// 关系
const relationStr =
  '配偶、父亲、母亲、儿子、儿媳、女儿、女婿、孙子、孙女、外孙、外孙女、祖父、祖母、外祖父、外祖母、哥哥、嫂子、弟弟、弟媳、姐姐、姐夫、妹妹、妹夫、婆婆、公公、岳父、岳母、叔父、婶母、姑父、姑母、舅舅、舅妈、姨父、姨妈、外甥、外甥女侄子、侄女、表兄、表弟、表姐、表妹、其他';
let temRelationList = relationStr.split('、');
export const relationList = temRelationList.map((item, index) => {
  return {
    value: index,
    label: item
  };
});

export const AfterSaleTypeList = [
  {
    value: 1,
    label: '换货',
    icon: '/assets/imgs/shop/afterSale/exchange.png',
    desc: '质量问题、货物破损、无理由换货',
    reasonList: [
      {
        value: '101',
        label: '货物破损、缺件'
      },
      {
        value: '102',
        label: '无理由换货'
      },
      {
        value: '103',
        label: '质量问题'
      }
      // {
      //   value: '999',
      //   label: '其他',
      // },
    ]
  },
  {
    value: 2,
    label: '维修',
    icon: '/assets/imgs/shop/afterSale/repair.png',
    desc: '设备故障无法使用或损坏进行维修',
    reasonList: [
      {
        value: '201',
        label: '设备故障'
      },
      {
        value: '999',
        label: '其他'
      }
    ]
  },
  {
    value: 3,
    label: '退货',
    icon: '/assets/imgs/shop/afterSale/cancel.png',
    desc: '已支付订单需要进行退货申请',
    reasonList: [
      { label: '需要重新购买', value: '301' },
      { label: '没用/少用/错用优惠', value: '308' },
      { label: '商品少件/漏发', value: '303' },
      { label: '发错货', value: '304' },
      { label: '未按约定时间发货', value: '305' },
      { label: '未送货上门', value: '306' },
      { label: '地址信息填写错误', value: '307' },
      { label: '个人原因不想要了', value: '302' },
      { label: '政策理解差异', value: '309' },
      { label: '商品/包装破损/污渍', value: '310' },
      { label: '商品临近保质期/过期', value: '311' },
      { label: '商品变质/发霉/有异物', value: '312' },
      { label: '商品质量问题', value: '313' },
      { label: '家人不同意', value: '314' },
      { label: '朋友/网上评价不好', value: '315' },
      { label: '产品不喜欢', value: '316' },
      // {label: '样本不合格', value: '317'},
      { label: '其他', value: '999' }
    ]
  },
  {
    value: 4,
    label: '快速退单',
    reasonList: [
      { value: '401', label: '重新购买' }
      // {value: '401', label: '快速撤单'}
    ]
  }
];
export const returnReason = {
  301: '需要重新购买',
  308: '没用/少用/错用优惠',
  303: '商品少件/漏发',
  304: '发错货',
  305: '未按约定时间发货',
  306: '未送货上门',
  307: '地址信息填写错误',
  302: '个人原因不想要了',
  309: '政策理解差异',
  310: '商品/包装破损/污渍',
  311: '商品临近保质期/过期',
  312: '商品变质/发霉/有异物',
  313: '商品质量问题',
  314: '家人不同意',
  315: '朋友/网上评价不好',
  316: '产品不喜欢',
  999: '其他'
};
export const companyList = [
  {
    value: '顺丰速运',
    label: '顺丰速运'
  },
  {
    value: '韵达快递',
    label: '韵达快递'
  },
  {
    value: '中通快递',
    label: '中通快递'
  },
  {
    value: '申通快递',
    label: '申通快递'
  },
  {
    value: 'EMS',
    label: 'EMS'
  },
  {
    value: '圆通快递',
    label: '圆通快递'
  },
  {
    value: '百世快递',
    label: '百世快递'
  },
  {
    value: '天天快递',
    label: '天天快递'
  },
  {
    value: '宅急送',
    label: '宅急送'
  },
  {
    value: '德邦快递',
    label: '德邦快递'
  }
];

export const flowTypeMap = {
  PAY: '支付（购物）',
  REFUND: '退款',
  RECHARGE: '充值',
  WITHDRAW: '提现',
  REPAYMENT: '还款',
  TRANSFER: '转账',
  HANDLE: '手工录入',
  WITHHOLD: '扣款',
  CISTERN_MQ: '核心推送修改蓄水池余额',
  AFTERSALEREFUND: '售后退款',
  AFTERSALERPAY: '售后支付',
  BIZSERVICEFEEPAY: '业务办理手续费',
  TICKETPAY: '门票支付',
  TMPCHARGE: '代充',
  STATUS_CHANGE: '身份转换',
  ARTIFICIAL: '人工操作'
};

export const CouponStatusMap = {
  NOT_USED: 1, // 未使用
  USED: 2, // 已使用
  FROZEN: 3, // 已冻结
  EXPIRED: 4 // 已过期
};

export const CouponTypeMap = {
  DEDUCTION: 1, // 抵扣券
  DISCOUNT: 2, // 折扣券
  QUALIFICATION: 3, // 资格券
  FREIGHT: 4, // 运费券
  EXCHANGE: 5, // 提货劵
  VERIFICATION: 6 // 提货劵
};

export const CouponTypeNameMap = {
  [CouponTypeMap.DEDUCTION]: '抵扣券', // 抵扣券
  [CouponTypeMap.DISCOUNT]: '折扣券', // 折扣券
  [CouponTypeMap.QUALIFICATION]: '资格券', // 资格券
  [CouponTypeMap.FREIGHT]: '运费券', // 运费券
  [CouponTypeMap.EXCHANGE]: '提货劵', // 提货劵
  [CouponTypeMap.VERIFICATION]: '核销券' // 核销券
};

// 购物下单配货比例类型
export const distributionRatioList = [{ label: '未选择', value: -1 }];
// 1：满减，5：折扣，6：加价购，7：预售，8：拼团，9：秒杀 ，10：资格购，11：优惠券，12：满赠
export const activityTypeMap = {
  specialGroup: 13, // 特殊拼团 13
  fullGift: 12, // 满赠
  coupon: 11, // 优惠券
  qualification: 10, // 资格购
  flashSale: 9, // 秒杀
  groupBuy: 8, // 拼团
  advanceSale: 7, // 预售
  addPrice: 6, // 加价购
  discount: 5, // 折扣
  fullReduction: 1 // 满减
};

export const activityTypeNameMap = {
  [activityTypeMap.specialGroup]: '特殊拼团',
  [activityTypeMap.fullGift]: '满赠',
  [activityTypeMap.coupon]: '优惠券',
  [activityTypeMap.qualification]: '资格购',
  [activityTypeMap.flashSale]: '秒杀',
  [activityTypeMap.groupBuy]: '拼团',
  [activityTypeMap.advanceSale]: '预售',
  [activityTypeMap.addPrice]: '加价购',
  [activityTypeMap.discount]: '折扣',
  [activityTypeMap.fullReduction]: '满减'
};

// 交易中心活动类型
export const payActivityTypeMap = {
  DISCOUNT: 1, // 折扣促销
  FULL_REDUCTION: 2, // 满减促销
  FULL_PRESENT: 3, // 满赠促销
  WITH_ADDITIONAL: 4, // 加价购促销
  FLASHSALE: 5, // 秒杀
  QUALIFICATION: 6, // 资格购
  COUPON: 7, // 优惠券
  GROUPBUY: 21, // 拼团
  ADVANCESALE: 20 // 预售
};

export const payActivityTypeNameMap = {
  [payActivityTypeMap.DISCOUNT]: '折扣',
  [payActivityTypeMap.FULL_REDUCTION]: '满减',
  [payActivityTypeMap.FULL_PRESENT]: '满赠',
  [payActivityTypeMap.WITH_ADDITIONAL]: '加价购',
  [payActivityTypeMap.FLASHSALE]: '秒杀',
  [payActivityTypeMap.QUALIFICATION]: '资格购',
  [payActivityTypeMap.COUPON]: '优惠券',
  [payActivityTypeMap.GROUPBUY]: '拼团',
  [payActivityTypeMap.ADVANCESALE]: '预售'
};

export const openCollect = '您还未完成上节课的学习，无法解锁该视频';
export const openCollect2 = '本课程还未到可观看的时间';
export const openCollect3 = '该课程尚未解锁，请耐心等待';
// '该课程尚未解锁，请耐心等待'

export const activityStatusMap = {
  activeInit: 0, // 新建
  activeInvalid: 1, // 待生效
  activeDoing: 2, // 进行中
  activePause: 3, // 暂停
  activeFinish: 4, // 已结束
  activeDisable: 5 // 禁用
};

// 预售的状态
export const advanceSaleStatusMap = {
  ACTIVITYUNSTART: 'ACTIVITYUNSTART', // 活动尚未开始
  PAYFORDEPOSIT: 'PAYFORDEPOSIT', // 支付定金
  WAITFORTAIL: 'WAITFORTAIL', // 待付尾款
  PAYFORTAIL: 'PAYFORTAIL', // 支付尾款
  ACTIVITYEND: 'ACTIVITYEND' // 活动结束
};

// 预售的形式
export const advanceSaleTypeMap = {
  DEPOSITSALE: 1, // 定金+尾款
  FULLPAYMENT: 2 // 全款
};

export const groupPriceSetMap = {
  CUSTOMIZE: 1, // 自定义售价
  UNITE: 2 // 统一团购价
};

// 拼团成团状态
export const groupOrderStatusMap = {
  WAITGROUP: 0, // 未成团
  HASGROUP: 1, // 已成团
  FAILGROUP: 2, // 拼团失败
  CANCELGROUP: 3 // 取消拼团
};

// 拼团订单状态
export const groupBuyStatusMap = {
  WAITPAY: 0, // 待付款
  GROUPING: 1, // 拼团中
  GROUPSUCCESS: 3, // 拼团成功
  GROUPFAIL: 2, // 拼团失败
  GROUPCANCEL: 4, // 已取消
  PARTIAL_DELIVERY: 5, // 部分发货
  DELIVERY: 6, // 待收货
  SUCC: 7 // 已完成
};

// 拼团状态中文
export const groupBuyStatusNameMap = {
  [groupBuyStatusMap.WAITPAY]: '待付款',
  [groupBuyStatusMap.GROUPING]: '未成团',
  [groupBuyStatusMap.GROUPSUCCESS]: '拼团成功',
  [groupBuyStatusMap.GROUPFAIL]: '拼团失败',
  [groupBuyStatusMap.GROUPCANCEL]: '已取消',
  [groupBuyStatusMap.PARTIAL_DELIVERY]: '部分发货',
  [groupBuyStatusMap.DELIVERY]: '待收货',
  [groupBuyStatusMap.SUCC]: '已完成'
};

// 拼团的形式
export const groupActionTypeMap = {
  STARTGROUP: 1, // 开团
  GROUPWITHOTHER: 2 // 参团
};

export const groupLabelMap = {
  REMOVESHELF: 0, // 已下架(失效)
  INAPPLICABLE: 1, // 不适用
  EFFECTIVE: 6, // 普通
  SALEZONE: 7, // 销售专区
  CRITICAL: 99 // 临界产品
};

export const groupLabelNameMap = {
  [groupLabelMap.REMOVESHELF]: '已下架产品',
  [groupLabelMap.INAPPLICABLE]: '不适用产品',
  [groupLabelMap.EFFECTIVE]: '普通产品',
  [groupLabelMap.SALEZONE]: '销售专区产品',
  [groupLabelMap.CRITICAL]: '已下架产品' // 这个比较特殊按照之前的逻辑，临期产品也显示了已下架产品
};

// 促销中心活动类型
export const promotionActivityTypeMap = {
  FLASHSALE: 9, // 秒杀
  GROUPBUY: 8, // 拼团
  ADVANCESALE: 7, // 预售
  FULL_PRESENT: 12, // 满赠
  WITH_ADDITIONAL: 6, // 加价购
  QUALIFICATION: 10, // 资格购
  SPECIALGROUPBUY: 13, // 特殊拼团
  FULLGIFT: 12 // 满赠
};

// 订单详情页订单状态背景图
export const orderDetailStatusBgMap = {
  INIT: 'wait_pay.png',
  WAIT_DELIVERY: 'wait_delivery.png',
  PARTIAL_DELIVERY: 'wait_delivery.png',
  DELIVERY: 'wait_receive.png',
  SUCC: 'had_finish.png',
  CANCEL: 'had_cancel.png',
  DEPOSIT: 'wait_pay.png',
  TAIL: 'wait_pay.png',
  TAIL_PAY_WAIT: 'wait_pay.png',
  [groupBuyStatusMap.WAITPAY]: 'wait_pay.png',
  [groupBuyStatusMap.GROUPING]: 'wait_pay.png',
  [groupBuyStatusMap.GROUPSUCCESS]: 'wait_delivery.png',
  [groupBuyStatusMap.GROUPFAIL]: 'had_cancel.png',
  [groupBuyStatusMap.GROUPCANCEL]: 'had_cancel.png',
  [groupBuyStatusMap.PARTIAL_DELIVERY]: 'wait_delivery.png', // 部分发货
  [groupBuyStatusMap.DELIVERY]: 'wait_receive.png',
  [groupBuyStatusMap.SUCC]: 'had_finish.png'
};

// 订单详情页订单状态
export const orderStatusNameMap = {
  INIT: '待付款',
  WAIT_DELIVERY: '待发货',
  PARTIAL_DELIVERY: '待收货',
  DELIVERY: '待收货',
  SUCC: '已完成',
  CANCEL: '已取消',
  DEPOSIT: '待付定金',
  TAIL: '待支付尾款',
  TAIL_PAY_WAIT: '待支付尾款',
  [groupBuyStatusMap.WAITPAY]: '待付款',
  [groupBuyStatusMap.GROUPING]: '未成团',
  [groupBuyStatusMap.GROUPSUCCESS]: '拼团成功',
  [groupBuyStatusMap.GROUPFAIL]: '拼团失败',
  [groupBuyStatusMap.GROUPCANCEL]: '已取消',
  [groupBuyStatusMap.PARTIAL_DELIVERY]: '待发货', // 部分发货
  [groupBuyStatusMap.DELIVERY]: '待收货',
  [groupBuyStatusMap.SUCC]: '已完成'
};

// 订单状态
export const orderStatusMap = {
  INIT: 'INIT', // 待付款
  WAIT_DELIVERY: 'WAIT_DELIVERY', // 待发货
  PARTIAL_DELIVERY: 'PARTIAL_DELIVERY', // 部分发货
  DELIVERY: 'DELIVERY', // 待收货
  SUCC: 'SUCC', // 已完成
  CANCEL: 'CANCEL', // 已取消
  DEPOSIT: 'DEPOSIT', // 待付定金
  TAIL: 'TAIL', // 待付尾款
  LIQUIDATION: 0, // 未结算
  TAIL_PAY_WAIT: 'TAIL_PAY_WAIT', // 待支付尾款
  WAITPAY: 0, // 待付款
  GROUPING: 1, // 拼团中
  GROUPSUCCESS: 3, // 拼团成功
  GROUPFAIL: 2, // 拼团失败
  GROUPCANCEL: 4, // 已取消
  GROUP_PARTIAL_DELIVERY: 5, // 部分发货
  GROUP_DELIVERY: 6, // 待收货
  GROUP_SUCC: 7, // 已完成
  GROUP_CANCLE: 8, // 已取消
  GROUP_PING: 9 // 特殊拼团拼团中
};

// 预售的状态
export const advanceSaleStatus = {
  ACTIVITYUNSTART: 'ACTIVITYUNSTART', // 活动尚未开始
  PAYFORDEPOSIT: 'PAYFORDEPOSIT', // 支付定金
  WAITFORTAIL: 'WAITFORTAIL', // 待付尾款
  PAYFORTAIL: 'PAYFORTAIL', // 支付尾款
  ACTIVITYEND: 'ACTIVITYEND', // 活动结束
  GOBUY: 'GOBUY' // 立即购买，预售全款的状态下
};

// 交易中心活动类型
export const payActivityType = {
  DISCOUNT: 1, // 折扣促销
  FULL_REDUCTION: 2, // 满减促销
  FULL_PRESENT: 3, // 满赠促销
  WITH_ADDITIONAL: 4, // 加价购促销
  FLASHSALE: 5, // 秒杀
  QUALIFICATION: 6, // 资格购
  COUPON: 7, // 优惠券
  GROUPBUY: 21, // 拼团
  ADVANCESALE: 20 // 预售
};

export const CourseWaveMap = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  PDF: 'PDF'
};

export const recommendMap = {
  ZJY: 'ZJY', // 中间页
  MRYT: 'MRYT', // 每日商道
  XXJH: 'XXJH', // 学习计划
  XXPX: 'XXPX', // 学习培训
  HOME: 'HOME', // 首页
  SXY: 'SXY', // 商学院
  JYKT: 'JYKT', // 精英课堂
  YFZSXY: 'YFZSXY' // 一分钟商学院
};

export const giftTypeMap = {
  ENTITY: 1, // 实物
  COUPON: 2, // 兑换劵
  RIGHT: 3, // 权益
  MIXED: 5 // 优惠券+实物组合
};

export const presentWayMap = {
  PRESENT_ALL: 1, // 全部赠送
  PRESENT_NUMBER: 3, // 任选个数
  PRESENT_TYPE: 2 // 任选种类
};

export const activityTipTitleMap = {
  8458: '复消资格',
  8858: '活动库存限制',
  8859: '用户选择折扣非法',
  8860: '折扣商品与非折扣商品无法同时下单',
  8861: '下单门槛'
};

export const contentTipPosTypeMap = {
  CONFIRMORDER: 1, // 确认订单
  PAYSUCCESS: 2, // 支付完成
  NOTPAY: 3, // 退出支付
  ACTIVECARD: 4, // 开卡完成 h5不做处理
  CONFIRMORDER2: 5, // 虚拟商品 确认订单
  PAYSUCCESS2: 6, // 虚拟商品 支付完成
  NOTPAY2: 7 // 虚拟商品 退出支付
};

export const routeAuthCodeMap = {
  PERSONAL_INVOICE: 'PERSONAL_INVOICE', // 我的发票
  EVALUATION_SWITCH: 'EVALUATION_SWITCH', // 我的评价
  PERSONAL_AFTER_SALE: 'PERSONAL_AFTER_SALE', // 我的-我的售后
  PERSONAL_UPGRADE: 'PERSONAL_UPGRADE', // 我的-升级
  APPLY_STORE_JOINT_CREATION: 'APPLY_STORE_JOINT_CREATION', // 我的-申请合伙人
  PERSONAL_STORE: 'PERSONAL_STORE', // 我的-申请开店
  PERSONAL_STORE_AUDIT: 'PERSONAL_STORE_AUDIT', // 我的-申请结果
  PERSONAL_FAST_SHOPPING: 'PERSONAL_FAST_SHOPPING', // 我的-快速购物
  PERSONAL_COLLECTED: 'PERSONAL_COLLECTED', // 我的-我的收藏
  PERSONAL_FOOTPRINT: 'PERSONAL_FOOTPRINT', // 我的-浏览足迹
  PERSONAL_SHIPPING_ADDR: 'PERSONAL_SHIPPING_ADDR', // 我的-收货地址
  PERSONAL_TEAM: 'PERSONAL_TEAM', // 我的-我的拼团
  PERSONAL_PROXY_AFTER_SALE: 'PERSONAL_PROXY_AFTER_SALE', // 我的-代客售后
  PERSONAL_PROXY_PLACE_ORDER: 'PERSONAL_PROXY_PLACE_ORDER', // 我的-代客下单
  NOMAL_WALLET: 'NOMAL_WALLET', // 我的-充值钱包
  NOMAL_WALLET_RECHARE: 'NOMAL_WALLET_RECHARE', // 充值钱包-充值
  INTERNATIONAL_WALLET_RECHARE: 'INTERNATIONAL_WALLET_RECHARE', // 我的-充值钱包
  NOMAL_WALLET_DETAIL: 'NOMAL_WALLET_DETAIL', // 充值钱包-明细
  NOMAL_WALLET_WITHDRAWAL: 'NOMAL_WALLET_WITHDRAWAL', // 充值钱包-提现
  NOMAL_WALLET_TRANSFER: 'NOMAL_WALLET_TRANSFER', // 充值钱包-转账
  CISTERN_WALLET: 'CISTERN_WALLET', // 我的-换购钱包
  CISTERN_WALLET_DETAIL: 'CISTERN_WALLET_DETAIL', // 换购钱包-明细
  BONUS_WALLET: 'BONUS_WALLET', // 我的-分享钱包
  BONUS_WALLET_DETAIL: 'BONUS_WALLET_DETAIL', // 分享钱包-明细
  BONUS_WALLET_TRANSFER: 'BONUS_WALLET_TRANSFER', // 分享钱包-转账
  BONUS_WALLET_WITHDRAWAL: 'BONUS_WALLET_WITHDRAWAL', // 分享钱包-提现
  INTERNATIONAL_WALLET_WITHDRAWAL: 'INTERNATIONAL_WALLET_WITHDRAWAL', // 国际钱包-提现
  INTERNATIONAL_WALLET_TRANSFER: 'INTERNATIONAL_WALLET_TRANSFER', // 国际钱包-转账
  INTERNATIONAL_WALLET_DETAIL: 'INTERNATIONAL_WALLET_DETAIL', // 国际钱包-明细
  INTEGRAL_WALLET_DETAIL: 'INTEGRAL_WALLET_DETAIL', // 甄选钱包-明细
  INTEGRAL_WALLET_TRANSFER: 'INTEGRAL_WALLET_TRANSFER', // 站选钱包-转账
  LIANCHUANG_WALLET: 'LIANCHUANG_WALLET', // 联创钱包
  LIANCHUANG_WALLET_DETAILS: 'LIANCHUANG_WALLET_DETAILS', // 联创钱包-明细
  LIANCHUANG_WALLET_TRANSFER: 'LIANCHUANG_WALLET_TRANSFER', // 联创钱包-转账
  PAY_PASSWORD: 'PAY_PASSWORD', // 我的-支付密码
  BANK_CARD: 'BANK_CARD', // 我的-银行卡
  PERSONAL_TO_UP: 'PERSONAL_TO_UP', // 我的-充值
  PERSONAL_TRADE_PARTICULARS: 'PERSONAL_TRADE_PARTICULARS', // 我的-交易明细
  PERSONAL_DISCOUNT_COUPON: 'PERSONAL_DISCOUNT_COUPON', // 我的-优惠券
  PERSONAL_INTEGRAL: 'PERSONAL_INTEGRAL', // 我的-积分
  PERSONAL_REFUNDS: 'PERSONAL_REFUNDS', // 我的-充值退款
  PERSONAL_NEWBIE_TUTORIAL: 'PERSONAL_NEWBIE_TUTORIAL', // 我的-新手教程
  PERSONAL_SIGN_IN: 'PERSONAL_SIGN_IN', // 我的-打卡
  PERSONAL_INVITE: 'PERSONAL_INVITE', // 我的-邀请开卡
  PERSONAL_NEW: 'PERSONAL_NEW', // 我的-新客注册
  PERSONAL_BROWSE_CARD: 'PERSONAL_BROWSE_CARD', // 我的-开卡浏览
  PERSONAL: 'PERSONAL', // 我的-个人中心
  LIVE: 'LIVE', // 展业、我的-直播
  BINDING_HEALTH_CLUB: 'BINDING_HEALTH_CLUB', // 我的-绑定养生馆
  EXPAND_SCHEDULE: 'EXPAND_SCHEDULE', // 展业-日程管理
  EXPAND_CUSTOME: 'EXPAND_CUSTOME', // 展业-客户管理
  EXPAND_MATERIAL: 'EXPAND_MATERIAL', // 展业-素材中心
  EXPAND_MARK: 'EXPAND_MARK', // 展业-业绩中心
  EXPAND_SERVICE: 'EXPAND_SERVICE', // 展业-服务大厅
  EXPAND_TRAIN: 'EXPAND_TRAIN', // 展业-培训中心
  EXPAND_TRAIN_NEW: 'EXPAND_TRAIN_NEW', // 展业-培训中心
  EXPAND_TRAIN_MINI_PROGRAM: 'EXPAND_TRAIN_MINI_PROGRAM', // 展业-培训中心-小程序
  EXPAND_SELFINFO: 'EXPAND_SELFINFO', // 展业-我的名片
  EXPAND_RIGHTS: 'EXPAND_RIGHTS', // 展业-我的权益
  EXPAND_ACTIVITY: 'EXPAND_ACTIVITY', // 展业-活动中心
  PERFORMANCE: 'PERFORMANCE', // 有享助手-个人业绩
  SCOPE_MANAGEMENT: 'SCOPE_MANAGEMENT', // 有享助手-区域管理
  COMMISSION: 'COMMISSION', // 有享助手-我的销售费
  CONTRACT_QUERY: 'CONTRACT_QUERY', // 有享助手-续约查询
  MODIFY_ADDR_2: 'MODIFY_ADDR_2', // 店铺-代客下单-修改地址
  MODIFY_ADDR: 'MODIFY_ADDR', // 我的-代客下单-修改地址
  CLASSIFICATION_ICON: 'CLASSIFICATION_ICON', // 分类图标
  MEDICAL_RECORD: 'MEDICAL_RECORD', // 既往病史权限点
  STOREENTRY_MAIN: 'STOREENTRY_MAIN', // 店铺总入口
  PERSONAL_PROFILE: 'PERSONAL_PROFILE', // 我的档案
  VIRTUAL_QUALIFICATION: 'VIRTUAL_QUALIFICATION', // 虚拟点位的权限点
  PERSONAL_PROXY_UPGRADE_ORDER: 'PERSONAL_PROXY_UPGRADE_ORDER', // 会员代客升级
  SHARE_APP: 'SHARE_APP', // 我的-分享APP
  ONLINE_SERVICE: 'ONLINE_SERVICE', // 在线客服
  EXPAND_APPLY_STORE: 'EXPAND_APPLY_STORE', // 申请开店
  EXPAND_PROXY_CHANGE_NAME: 'EXPAND_PROXY_CHANGE_NAME', // 展业-代客更名
  EXPAND_PROXY_CHANGE_INFO: 'EXPAND_PROXY_CHANGE_INFO', // 展业-代客更改资料
  SERVICE_CODE: 'SERVICE_CODE', // 服务码
  COMPLETE_MATERIAL: 'COMPLETE_MATERIAL', // 完善资料入口权限点：
  MEMBER_LEVEL: 'MEMBER_LEVEL', // 会员级别
  PERSONAL_SHARE: 'PERSONAL_SHARE', // 访客我的分享
  BUSINESS_MANAGE: 'BUSINESS_MANAGE', // 店铺-业务管理
  NEW_CUSTOMER_REGIST: 'NEW_CUSTOMER_REGIST', // 店铺-业务管理-新客注册
  OLD_CUSTOMER_UPRADE: 'OLD_CUSTOMER_UPRADE', // 店铺-业务管理-老客升级
  PROXY_ORDER_2: 'PROXY_ORDER_2', // 店铺-业务管理-代客下单
  ORDER_CHANGE_PERIOD: 'ORDER_CHANGE_PERIOD', // 店铺-业务管理-订单调期
  OPEN_CARD_BROWSE: 'OPEN_CARD_BROWSE', // 店铺-业务管理-开卡浏览
  PROXY_AFTER_SALE: 'PROXY_AFTER_SALE', // 店铺-业务管理-代客售后
  STORE_WALLET: 'STORE_WALLET', // 店铺-钱包
  STORE_WALLET_PAY: 'STORE_WALLET_PAY', // 店铺-钱包-钱包
  STORE_WALLET_RECHARGE: 'STORE_WALLET_RECHARGE', // 店铺-钱包-充值
  STORE_TRADE_DETAIL: 'STORE_TRADE_DETAIL', // 店铺-钱包-交易明细
  STORE_WALLET_WITHDRAW: 'STORE_WALLET_WITHDRAW', // 店铺-钱包-提现
  BUSINESS_SEARCH_OTHERS: 'BUSINESS_SEARCH_OTHERS', // 店铺-查询业务与其他
  STORE_CUSTOMER_SERVICE: 'STORE_CUSTOMER_SERVICE', // 店铺-查询业务与其他-客服
  STORE_INFORMATION: 'STORE_INFORMATION', // 店铺-查询业务与其他-工作室资料
  STORE_ADDRESS: 'STORE_ADDRESS', // 店铺-查询业务与其他-工作室地址
  STORE_VIP_SEARCH: 'STORE_VIP_SEARCH', // 店铺-查询业务与其他-复消查询
  STORE_PASSWORD: 'STORE_PASSWORD', // 店铺-查询业务与其他-密码
  STORE_SON_MANAGE: 'STORE_SON_MANAGE', // 店铺-查询业务与其他-子账号管理
  STORE_CUSTOMERS_RIGHTS: 'STORE_CUSTOMERS_RIGHTS', // 店铺-查询业务与其他-消费者权益
  STORE_ORDER_LIST: 'STORE_ORDER_LIST', // 店铺-代客订单
  STUDIO_UPGRADE: 'STUDIO_UPGRADE', // 店铺-工作室升级
  DOWNLOAD_BOOT: 'DOWNLOAD_BOOT', // 是否显示H5下载引导
  PERSONAL_BATCH_ORDER: 'PERSONAL_BATCH_ORDER', // 我的-购物管理-肽素乳畅享卡
  SELECTIO_ITEM: 'SELECTIO_ITEM', // 我的-财务管理-甄选商城
  EQUITY_STORAGE: 'EQUITY_STORAGE', // 我的-财务管理-腾晖云仓
  EXHIBITION_ON_OFF: 'EXHIBITION_ON_OFF', // 展业总开关
  MAIN_BINDING_CARD: 'MAIN_BINDING_CARD', // 主卡/附属卡
  UPGRADE_FLOATWIN: 'UPGRADE_FLOATWIN', // 首页去升级悬浮窗
  POSTER: 'POSTER', // 海报
  COUPON_DETAIL: 'COUPON_DETAIL', // 优惠券使用明细

  EXPAND_GIFT_WAREHOUSE: 'EXPAND_GIFT_WAREHOUSE', //展业-礼品仓
  EXPAND_PROXY_PLACE_ORDER: 'EXPAND_PROXY_PLACE_ORDER', //展业-代客下单
  EXPAND_POSTER: 'EXPAND_POSTER', //展业-海报
  EXPAND_OPEN_CARD_BROWSE: 'EXPAND_OPEN_CARD_BROWSE', //展业-开卡浏览
  EXPAND_AI_CLOUD_HEALTH: 'EXPAND_AI_CLOUD_HEALTH', //展业-AI云健康
  EXPAND_STOREENTRY: 'EXPAND_STOREENTRY', //展业-店铺入口
  APPLY_CSTORE: 'APPLY_CSTORE', //展业-申请开店
  ONLINE_PRESCRIPTION: 'ONLINE_PRESCRIPTION', //展业-在线开单
  EXPANDENTRY_AI_CREATE: 'EXPANDENTRY_AI_CREATE', // AI星球
  EXPANDENTRY_AI_DIGETAL_PEOPLE: 'EXPANDENTRY_AI_DIGETAL_PEOPLE', //AI数字人
  ONLINE_EXAM: 'ONLINE_EXAM', // 店长考试
  CHAIN_ONLINE_SBN: 'CHAIN_ONLINE_SBN', // 视百年云连锁
  CHAIN_ONLINE_MR: 'CHAIN_ONLINE_MR', // 美容云连锁
  CHAIN_ONLINE_JL: 'CHAIN_ONLINE_JL', // 经络云连锁
  DREAM_ASSISTANCE: 'DREAM_ASSISTANCE', // 我的-助梦计划
  MY_LIFE_COUPON: 'MY_LIFE_COUPON' // 我的-其他-生活券
};

export const tagAuthCodeMap = {
  EXPAND_EXPIRE: 'EXPAND_EXPIRE', // 展业-有效期
  EXPAND_CARDTYPE: 'EXPAND_CARDTYPE', // 展业-卡类型
  PERSONAL_CARDTYPE: 'PERSONAL_CARDTYPE', // 我的-卡类型
  PERSONAL_MEM_STATUS: 'PERSONAL_MEM_STATUS', // 我的-会员状态
  PERSONAL_SHOP: 'PERSONAL_SHOP', // 我的-显示所属店铺
  UPDATE_PERSONAL_SHOP: 'UPDATE_PERSONAL_SHOP', // 我的-修改所属店铺
  PERSONAL_VIP_ICON: 'PERSONAL_VIP_ICON', // 我的、展业-vip图标
  FAST_CANCELLATIONS_2: 'FAST_CANCELLATIONS_2', // 店铺-代客订单-快速撤单
  FAST_CANCELLATIONS: 'FAST_CANCELLATIONS', // 我的-订单-快速撤单
  STORE_PROXY_BUY: 'STORE_PROXY_BUY', // 店铺-代客下单-代客下单
  MEMBER_PROXY_BUY: 'MEMBER_PROXY_BUY', // 会员-代客下单-会员下单
  EXPAND_STORE_MARK: 'EXPAND_STORE_MARK', // 店铺标识
  PAY_WAY: 'PAY_WAY', // 支付方式
  EXPAND_CARD_GRAPH: 'EXPAND_CARD_GRAPH', // 展业-卡图标
  STORE_UPGRADE: 'STORE_UPGRADE', // 店铺-升级小店
  ORDER_FILTER: 'ORDER_FILTER', // 我的入口-我的订单-订单类型筛选
  PHASE_SCREENING: 'PHASE_SCREENING', // 我的入口-我的订单-期数筛选
  PICK_UP: 'PICK_UP', // 我的入口-我的订单-自提收货
  STORE_COLLECTION: 'STORE_COLLECTION', // 我的入口-我的订单-店铺代收
  MEMBER_LEVEL: 'MEMBER_LEVEL', // 会员级别
  SALE_LEVEL: 'SALE_LEVEL', // 我的-销售级别（会员级别）
  PERSONAL_SHARE: 'PERSONAL_SHARE', // 访客我的分享
  ID_CARD: 'ID_CARD', // 身份证明
  HOUSEHOLD_REGISTRATION_BOOK: 'HOUSEHOLD_REGISTRATION_BOOK', // 户口本
  EDUCATION_CERTIFICATE: 'EDUCATION_CERTIFICATE', // 学历证书
  STANDARD_ONE_INCH_PHOTO: 'STANDARD_ONE_INCH_PHOTO', // 标准一寸照
  PROOF_OF_RELATIONSHIP: 'PROOF_OF_RELATIONSHIP', // 关系证明
  MARRIAGE_CERTIFICATE: 'MARRIAGE_CERTIFICATE', // 结婚证
  TAX_AUTHORIZATION_LETTER: 'TAX_AUTHORIZATION_LETTER', // 税务委托书
  BUSINESS_LICENSE: 'BUSINESS_LICENSE', // 营业执照
  LETTER_FOR_INVOICING: 'LETTER_FOR_INVOICING', // 开票承诺函
  OTHER_CERTIFICATION: 'OTHER_CERTIFICATION', // 其他证书
  CLOUD_BEAN_STORE: 'CLOUD_BEAN_STORE', // 云豆商城
  EXPAND_RETAIL_RATING: 'EXPAND_RETAIL_RATING', // 当月复消战力值
  ACCOUNT_NAME: 'WITHDRAWAL_UPDATE_REAL_NAME', // 提现账号姓名
  CONNECT_PHONE: 'WITHDRAWAL_UPDATE_PHONE', // 提现联系方式
  ISCERTIFIED: 'ISCERTIFIED' // 我的-实体店认证
};

export const taskCodeMap = {
  CLOCK: 'clock_clock', // 打卡
  GIFT: 'clock_download_gift', // 下载有礼
  EYE: 'clock_eye', // 浏览商品
  SHARE: 'clock_share_goods', // 分享商品到微信
  KEEPCLOCK: 'clock_keepclock', // 连续打卡
  AIDIRECT: 'clock_cloud_health_ai_detect' // 云健康AI检测
};

export const activityStatus = {
  1: '待开启',
  2: '进行中',
  3: '已结束'
};

export const gradeMap = {
  CITY: 'city', // 市
  COUNTY: 'county', // 区
  PROVINCE: 'province', // 省
  STREET: 'street', //街道
  COMMUNITY: 'community' //社区
};

export const FormList = [
  {
    labelName: '会员卡号',
    elementName: 'userCard',
    elementType: 'input',
    elementValues: []
  },
  {
    labelName: '姓名',
    elementName: 'userName',
    elementType: 'input',
    elementValues: []
  },
  {
    labelName: '手机号码',
    elementName: 'phone',
    elementType: 'input',
    elementValues: []
  },
  {
    labelName: '证件类型',
    elementName: 'certificateType',
    elementType: 'select',
    elementValues: [
      { label: '身份证', value: 1 },
      { label: '护照', value: 2 },
      { label: '港澳台证', value: 3 },
      { label: '其他证件', value: 4 }
    ]
  },
  {
    labelName: '证件号码',
    elementName: 'identityNumber',
    elementType: 'input',
    elementValues: []
  },
  {
    labelName: '民族',
    elementName: 'nation',
    elementType: 'select',
    elementValues: [
      { value: 0, label: '汉族' },
      { value: 1, label: '蒙古族' },
      { value: 2, label: '回族' },
      { value: 3, label: '藏族' },
      { value: 4, label: '维吾尔族' },
      { value: 5, label: '苗族' },
      { value: 6, label: '彝族' },
      { value: 7, label: '壮族' },
      { value: 8, label: '布依族' },
      { value: 9, label: '朝鲜族' },
      { value: 10, label: '满族' },
      { value: 11, label: '侗族' },
      { value: 12, label: '瑶族' },
      { value: 13, label: '白族' },
      { value: 14, label: '土家族' },
      { value: 15, label: '哈尼族' },
      { value: 16, label: '哈萨克族' },
      { value: 17, label: '傣族' },
      { value: 18, label: '黎族' }
    ]
  },
  {
    labelName: '出行方式',
    elementName: 'tripMode',
    elementType: 'select',
    elementValues: [
      { label: '飞机', value: 1 },
      { label: '高铁', value: 2 },
      { label: '自驾', value: 3 },
      { label: '课程', value: 4 },
      { label: '其他', value: 4 }
    ]
  },
  {
    labelName: '紧急联系人',
    elementName: 'contactPerson',
    elementType: 'input',
    elementValues: []
  },
  {
    labelName: '户籍所在地',
    elementName: 'censusAddr',
    elementType: 'censusPicker',
    elementValues: []
  },
  {
    labelName: '住宿要求',
    elementName: 'accommodation',
    elementType: 'input',
    elementValues: []
  },
  {
    labelName: '服装尺码',
    elementName: 'clothingSize',
    elementType: 'select',
    elementValues: [
      { label: 'S', value: 1 },
      { label: 'M', value: 2 }
    ]
  },
  {
    labelName: '是否清真/素食',
    elementName: 'vegetableDiet',
    elementType: 'select',
    elementValues: [
      { value: 0, label: '清真' },
      { value: 1, label: '素食' }
    ]
  },
  {
    labelName: '是否伉俪参会',
    elementName: 'travel',
    elementType: 'select',
    elementValues: [
      { value: 0, label: '否' },
      { value: 1, label: '是' }
    ]
  },
  {
    labelName: '上传证件照',
    elementName: 'identifyPhoto',
    elementType: 'photoPicker',
    elementValues: []
  },
  {
    labelName: '防疫信息',
    elementName: 'defendInfo',
    elementType: 'defendPicker',
    elementValues: []
  }
];

// 订单来源
export const orderSourceTypeMap = {
  you_xiang: '蜂鸟',
  middle: '有享云商'
};
/**
 * 首页跳转类型
 */
export const homeJumpType = {
  /**
   * 跳转到自定义链接
   */
  link: '1',
  /**
   * 跳转到产品详情
   */
  productDetail: '2',
  /**
   * 根据id列表跳转到产品列表
   */
  productList: '3',
  /**
   * 跳转到文章详情
   */
  article: '4',
  /**
   * 根据keyword跳转到产品列表
   */
  keywordProductList: '5',
  /**
   * 促销活动跳转
   */
  activityNormal: '6',
  /**
   * 主题活动跳转
   */
  activityTheme: '7',
  /**
   * 专题跳转
   */
  activitySpecial: '8',
  /**
   * 资格购跳转
   */
  qualification: '9',
  /**
   * 会员开卡
   */
  openCard: '10'
};

export const drawSceneType = {
  RECONSTITUTION_CLOCK: 2 // 复消专区打卡分享
};

// 购物下单订单类型
export const OrderTypeList = [
  //这个会根据不同的站点修改零售订单和复消订单的label，在init+Mobx里面
  {
    label: '零售订单',
    value: 1
  },
  {
    label: '复消订单',
    value: 2
  }
];

// 弹窗位置
export const popupPositionMap = {
  PRODUCT_PAY_COMPLETED: 1, // 商品订单-确认订单
  PRODUCT_PAY_CONFIRM: 2, // 商品订单-支付完成
  PRODUCT_PAY_EXIT: 3, // 商品订单-退出支付
  CARD_OEDER_COMPLETED: 4, // 开卡订单-开卡完成
  VIRTUALLY_OEDER_CONFIRM: 5, // 虚拟商品-确认订单
  VIRTUALLY_PAY_CONFIRM: 6, // 虚拟商品-支付完成
  VIRTUALLY_PAY_EXIT: 7, // 虚拟商品-退出支付
  REGISTRATION_COMPLETED: 8, // 注册完成
  HOME: 9, // 首页
  PERSONAL: 10, // 我的
  SPECIAL: 12, // 专题页
  FIRST_CLASS: 14, // 获得头等舱资格
  BEAN_PRODUCT_PAY_CONFIRM: 16, // 三生豆商品-确认订单
  BEAN_PRODUCT_PAY_COMPLETED: 17, // 三生豆商品-支付完成
  BEAN_PRODUCT_PAY_EXIT: 18, // 三生豆商品-退出支付
  RIGHTSCENTER: 19 // 我的权益中心
};

export const offlineActivityStatusMap = {
  ACTIVITY_BEGIN: 0, // 待开启
  ACTIVITYING: 1, // 活动进行中
  ACTIVITYEND: 2 // 活动已结束
};

export const openCardText = '升级小店';
export const oldOpenCardTextName = '申请开卡';
export const openCardTextLess = '升级';
export const oldOpenCardText = '开卡';
export const newDiscountGuster = '会员';
export const normalDiscountGuster = '优惠顾客';

export const cardTypeText = {
  '-2': '普客',
  '-1': '优惠顾客',
  0: '普卡',
  1: '银卡',
  2: '金卡',
  3: '钻卡',
  4: '钻1',
  5: '钻2',
  6: '钻3',
  10: 'VIP',
  20: '消费VIP'
};

export const colorEnumList = [
  {
    bgcolor: 'initial',
    value: '0'
  },
  {
    bgcolor: 'rgba(35, 53, 66, .5)',
    value: '1'
  },
  {
    bgcolor: 'rgba(59, 151, 137, .5)',
    value: '2'
  },
  {
    bgcolor: 'rgba(73, 173, 75, .5)',
    value: '3'
  },
  {
    bgcolor: 'rgba(71, 187, 216, .5)',
    value: '4'
  },
  {
    bgcolor: 'rgba(62, 77, 183, .5)',
    value: '5'
  },
  {
    bgcolor: 'rgba(104, 52, 185, .5)',
    value: '6'
  },
  {
    bgcolor: 'rgba(236, 33, 105, .5)',
    value: '7'
  },
  {
    bgcolor: 'rgba(248, 198, 4, .5)',
    value: '8'
  },
  {
    bgcolor: 'rgba(242, 86, 8, .5)',
    value: '9'
  },
  {
    bgcolor: 'rgba(240, 66, 44, .5)',
    value: '10'
  }
];
export const countryList = [
  {
    areaName: '中国',
    checkKey: '^(86){0,1}1\\d{10}$',
    code: '86',
    value: '86',
    label: '+86(中国)',
    domainAbbreviation: 'CN',
    code2: '86'
  },
  {
    areaName: '中国香港',
    checkKey: '^(00){0,1}(852){1}0{0,1}[1,4,5,6,8,9](?:\\d{7}|\\d{8}|\\d{12})$',
    code: '852',
    domainAbbreviation: 'HK',
    code2: '852'
  },
  {
    areaName: '中国澳门',
    checkKey: '^(00){0,1}(853){1}6\\d{7}$',
    code: '853',
    domainAbbreviation: 'MO',
    code2: '853'
  },
  {
    areaName: '中国台湾',
    checkKey: '^(00){0,1}(886){1}0{0,1}[6,7,9](?:\\d{7}|\\d{8}|\\d{10})$',
    code: '886',
    domainAbbreviation: 'TW',
    code2: '886'
  },
  {
    areaName: '韩国',
    checkKey: '^(00){0,1}(82){1}0{0,1}[7,1](?:\\d{8}|\\d{9})$',
    code: '82',
    domainAbbreviation: 'KR',
    code2: '82'
  },
  {
    areaName: '日本',
    checkKey: '^(00){0,1}(81){1}0{0,1}[7,8,9](?:\\d{8}|\\d{9})$',
    code: '81',
    domainAbbreviation: 'JP',
    code2: '81'
  },
  {
    areaName: '美国',
    checkKey: '^(00){0,1}(1){1}\\d{10,12}$',
    code: '1',
    domainAbbreviation: 'US',
    code2: 'US'
  },
  {
    areaName: '加拿大',
    checkKey: '^(00){0,1}(1){1}\\d{10}$',
    code: '1',
    domainAbbreviation: 'CA',
    code2: 'CA'
  },
  {
    areaName: '英国',
    checkKey: '^(00){0,1}(44){1}[347-9](\\d{8,9}|\\d{11,12})$',
    code: '44',
    domainAbbreviation: 'GB',
    code2: '44'
  },
  {
    areaName: '澳大利亚',
    checkKey: '^(00){0,1}(61){1}4\\d{8,9}$',
    code: '61',
    domainAbbreviation: 'AU',
    code2: '61'
  },
  {
    areaName: '新加坡',
    checkKey: '^(00){0,1}(65){1}[13689]\\d{6,7}$',
    code: '65',
    domainAbbreviation: 'SG',
    code2: '65'
  },
  {
    areaName: '马来西亚',
    checkKey: '^(00){0,1}(60){1}1\\d{8,9}$',
    code: '60',
    domainAbbreviation: 'MY',
    code2: '60'
  },
  {
    areaName: '泰国',
    checkKey: '^(00){0,1}(66){1}[13456789]\\d{7,8}$',
    code: '66',
    domainAbbreviation: 'TH',
    code2: '66'
  },
  {
    areaName: '越南',
    checkKey: '^(00){0,1}(84){1}[1-9]\\d{6,9}$',
    code: '84',
    domainAbbreviation: 'VN',
    code2: '84'
  },
  {
    areaName: '菲律宾',
    checkKey: '^(00){0,1}(63){1}[24579](\\d{7,9}|\\d{12})$',
    code: '63',
    domainAbbreviation: 'PH',
    code2: '63'
  },
  {
    areaName: '印度尼西亚',
    checkKey: '^(00){0,1}(62){1}[2-9]\\d{7,11}$',
    code: '62',
    domainAbbreviation: 'ID',
    code2: '62'
  },
  {
    areaName: '德国',
    checkKey: '^(00){0,1}(49){1}1(\\d{5,6}|\\d{9,12})$',
    code: '49',
    domainAbbreviation: 'DE',
    code2: '49'
  },
  {
    areaName: '意大利',
    checkKey: '^(00){0,1}(39){1}[37]\\d{8,11}$',
    code: '39',
    domainAbbreviation: 'IT',
    code2: '39'
  },
  {
    areaName: '法国',
    checkKey: '^(00){0,1}(33){1}(\\d{6}|\\d{8,10})$',
    code: '33',
    domainAbbreviation: 'FR',
    code2: '33'
  },
  {
    areaName: '俄罗斯',
    checkKey: '^(00){0,1}(7){1}[13489]\\d{9,11}$',
    code: '7',
    domainAbbreviation: 'RU',
    code2: 'RU'
  },
  {
    areaName: '新西兰',
    checkKey: '^(00){0,1}(64){1}[278]\\d{7,9}$',
    code: '64',
    domainAbbreviation: 'NZ',
    code2: '64'
  },
  {
    areaName: '荷兰',
    checkKey: '^(00){0,1}(31){1}6\\d{8}$',
    code: '31',
    domainAbbreviation: 'NL',
    code2: '31'
  },
  {
    areaName: '瑞典',
    checkKey: '^(00){0,1}(46){1}[124-7](\\d{8}|\\d{10}|\\d{12})$',
    code: '46',
    domainAbbreviation: 'SE',
    code2: '46'
  },
  {
    areaName: '乌克兰',
    checkKey: '^(00){0,1}(380){1}[3-79]\\d{8,9}$',
    code: '380',
    domainAbbreviation: 'UA',
    code2: '380'
  },
  {
    areaName: '阿联酋',
    checkKey: '^(00){0,1}(971){1}\\d{6,12}$',
    code: '971',
    domainAbbreviation: 'AE',
    code2: '971'
  },
  {
    areaName: '阿根廷',
    checkKey: '^(00){0,1}(54){1}\\d{6,12}$',
    code: '54',
    domainAbbreviation: 'AR',
    code2: '54'
  },
  {
    areaName: '奥地利',
    checkKey: '^(00){0,1}(43){1}\\d{6,12}$',
    code: '43',
    domainAbbreviation: 'AT',
    code2: '43'
  },
  {
    areaName: '比利时',
    checkKey: '^(00){0,1}(32){1}\\d{6,12}$',
    code: '32',
    domainAbbreviation: 'BE',
    code2: '32'
  },
  {
    areaName: '保加利亚',
    checkKey: '^(00){0,1}(359){1}\\d{6,12}$',
    code: '359',
    domainAbbreviation: 'BG',
    code2: '359'
  },
  {
    areaName: '巴西',
    checkKey: '^(00){0,1}(55){1}\\d{6,12}$',
    code: '55',
    domainAbbreviation: 'BR',
    code2: '55'
  },
  {
    areaName: '巴哈马',
    checkKey: '^(00){0,1}(1242){1}\\d{6,12}$',
    code: '1242',
    domainAbbreviation: 'BS',
    code2: '1242'
  },
  {
    areaName: '白俄罗斯',
    checkKey: '^(00){0,1}(375){1}\\d{6,12}$',
    code: '375',
    domainAbbreviation: 'BY',
    code2: '375'
  },
  {
    areaName: '伯利兹',
    checkKey: '^(00){0,1}(501){1}\\d{6,12}$',
    code: '501',
    domainAbbreviation: 'BZ',
    code2: '501'
  },
  {
    areaName: '瑞士',
    checkKey: '^(00){0,1}(41){1}\\d{6,12}$',
    code: '41',
    domainAbbreviation: 'CH',
    code2: '41'
  },
  {
    areaName: '智利',
    checkKey: '^(00){0,1}(56){1}\\d{6,12}$',
    code: '56',
    domainAbbreviation: 'CL',
    code2: '56'
  },
  {
    areaName: '哥伦比亚',
    checkKey: '^(00){0,1}(57){1}\\d{6,12}$',
    code: '57',
    domainAbbreviation: 'CO',
    code2: '57'
  },
  {
    areaName: '丹麦',
    checkKey: '^(00){0,1}(45){1}\\d{6,12}$',
    code: '45',
    domainAbbreviation: 'DK',
    code2: '45'
  },
  {
    areaName: '爱沙尼亚',
    checkKey: '^(00){0,1}(372){1}\\d{6,12}$',
    code: '372',
    domainAbbreviation: 'EE',
    code2: '372'
  },
  {
    areaName: '埃及',
    checkKey: '^(00){0,1}(20){1}\\d{6,12}$',
    code: '20',
    domainAbbreviation: 'EG',
    code2: '20'
  },
  {
    areaName: '西班牙',
    checkKey: '^(00){0,1}(34){1}\\d{6,12}$',
    code: '34',
    domainAbbreviation: 'ES',
    code2: '34'
  },
  {
    areaName: '芬兰',
    checkKey: '^(00){0,1}(358){1}\\d{6,12}$',
    code: '358',
    domainAbbreviation: 'FI',
    code2: '358'
  },
  {
    areaName: '匈牙利',
    checkKey: '^(00){0,1}(36){1}\\d{6,12}$',
    code: '36',
    domainAbbreviation: 'HU',
    code2: '36'
  },
  {
    areaName: '希腊',
    checkKey: '^(00){0,1}(30){1}\\d{6,12}$',
    code: '30',
    domainAbbreviation: 'GR',
    code2: '30'
  },
  {
    areaName: '爱尔兰',
    checkKey: '^(00){0,1}(353){1}\\d{6,12}$',
    code: '353',
    domainAbbreviation: 'IE',
    code2: '353'
  },
  {
    areaName: '以色列',
    checkKey: '^(00){0,1}(972){1}\\d{6,12}$',
    code: '972',
    domainAbbreviation: 'IL',
    code2: '972'
  },
  {
    areaName: '印度',
    checkKey: '^(00){0,1}(91){1}\\d{6,12}$',
    code: '91',
    domainAbbreviation: 'IN',
    code2: '91'
  },
  {
    areaName: '约旦',
    checkKey: '^(00){0,1}(962){1}\\d{6,12}$',
    code: '962',
    domainAbbreviation: 'JO',
    code2: '962'
  },
  {
    areaName: '吉尔吉斯斯坦',
    checkKey: '^(00){0,1}(996){1}\\d{6,12}$',
    code: '996',
    domainAbbreviation: 'KG',
    code2: '996'
  },
  {
    areaName: '柬埔寨',
    checkKey: '^(00){0,1}(855){1}\\d{6,12}$',
    code: '855',
    domainAbbreviation: 'KH',
    code2: '855'
  },
  {
    areaName: '斯里兰卡',
    checkKey: '^(00){0,1}(94){1}\\d{6,12}$',
    code: '94',
    domainAbbreviation: 'LK',
    code2: '94'
  },
  {
    areaName: '立陶宛',
    checkKey: '^(00){0,1}(370){1}\\d{6,12}$',
    code: '370',
    domainAbbreviation: 'LT',
    code2: '370'
  },
  {
    areaName: '卢森堡',
    checkKey: '^(00){0,1}(352){1}\\d{6,12}$',
    code: '352',
    domainAbbreviation: 'LU',
    code2: '352'
  },
  {
    areaName: '摩洛哥',
    checkKey: '^(00){0,1}(212){1}\\d{6,12}$',
    code: '212',
    domainAbbreviation: 'MA',
    code2: '212'
  },
  {
    areaName: '蒙古',
    checkKey: '^(00){0,1}(976){1}\\d{6,12}$',
    code: '976',
    domainAbbreviation: 'MN',
    code2: '976'
  },
  {
    areaName: '马尔代夫',
    checkKey: '^(00){0,1}(960){1}\\d{6,12}$',
    code: '960',
    domainAbbreviation: 'MV',
    code2: '960'
  },
  {
    areaName: '尼日利亚',
    checkKey: '^(00){0,1}(234){1}\\d{6,12}$',
    code: '234',
    domainAbbreviation: 'NG',
    code2: '234'
  },
  {
    areaName: '墨西哥',
    checkKey: '^(00){0,1}(52){1}\\d{6,12}$',
    code: '52',
    domainAbbreviation: 'MX',
    code2: '52'
  },
  {
    areaName: '挪威',
    checkKey: '^(00){0,1}(47){1}\\d{6,12}$',
    code: '47',
    domainAbbreviation: 'NO',
    code2: '47'
  },
  {
    areaName: '巴拿马',
    checkKey: '^(00){0,1}(507){1}\\d{6,12}$',
    code: '507',
    domainAbbreviation: 'PA',
    code2: '507'
  },
  {
    areaName: '秘鲁',
    checkKey: '^(00){0,1}(51){1}\\d{6,12}$',
    code: '51',
    domainAbbreviation: 'PE',
    code2: '51'
  },
  {
    areaName: '波兰',
    checkKey: '^(00){0,1}(48){1}\\d{6,12}$',
    code: '48',
    domainAbbreviation: 'PL',
    code2: '48'
  },
  {
    areaName: '葡萄牙',
    checkKey: '^(00){0,1}(351){1}\\d{6,12}$',
    code: '351',
    domainAbbreviation: 'PT',
    code2: '351'
  },
  {
    areaName: '卡塔尔',
    checkKey: '^(00){0,1}(974){1}\\d{6,12}$',
    code: '974',
    domainAbbreviation: 'QA',
    code2: '974'
  },
  {
    areaName: '罗马尼亚',
    checkKey: '^(00){0,1}(40){1}\\d{6,12}$',
    code: '40',
    domainAbbreviation: 'RO',
    code2: '40'
  },
  {
    areaName: '塞尔维亚',
    checkKey: '^(00){0,1}(381){1}\\d{6,12}$',
    code: '381',
    domainAbbreviation: 'RS',
    code2: '381'
  },
  {
    areaName: '塞舌尔',
    checkKey: '^(00){0,1}(248){1}\\d{6,12}$',
    code: '248',
    domainAbbreviation: 'SC',
    code2: '248'
  },
  {
    areaName: '沙特阿拉伯',
    checkKey: '^(00){0,1}(966){1}\\d{6,12}$',
    code: '966',
    domainAbbreviation: 'SA',
    code2: '966'
  },
  {
    areaName: '突尼斯',
    checkKey: '^(00){0,1}(216){1}\\d{6,12}$',
    code: '216',
    domainAbbreviation: 'TN',
    code2: '216'
  },
  {
    areaName: '土耳其',
    checkKey: '^(00){0,1}(90){1}\\d{6,12}$',
    code: '90',
    domainAbbreviation: 'TR',
    code2: '90'
  },
  {
    areaName: '委内瑞拉',
    checkKey: '^(00){0,1}(58){1}\\d{6,12}$',
    code: '58',
    domainAbbreviation: 'VE',
    code2: '58'
  },
  {
    areaName: '英属维尔京群岛',
    checkKey: '^(00){0,1}(1284){1}\\d{6,12}$',
    code: '1284',
    domainAbbreviation: 'VG',
    code2: '1284'
  },
  {
    areaName: '南非',
    checkKey: '^(00){0,1}(27){1}\\d{6,12}$',
    code: '27',
    domainAbbreviation: 'ZA',
    code2: '27'
  },
  {
    areaName: '阿尔巴尼亚',
    checkKey: '^(00){0,1}(355){1}\\d{6,15}$',
    code: '355',
    domainAbbreviation: 'AL',
    code2: '355'
  },
  {
    areaName: '安哥拉',
    checkKey: '^(00){0,1}(244){1}\\d{6,15}$',
    code: '244',
    domainAbbreviation: 'AO',
    code2: '244'
  },
  {
    areaName: '阿塞拜疆',
    checkKey: '^(00){0,1}(994){1}\\d{6,15}$',
    code: '994',
    domainAbbreviation: 'AZ',
    code2: '994'
  },
  {
    areaName: '布基纳法索',
    checkKey: '^(00){0,1}(226){1}\\d{6,15}$',
    code: '226',
    domainAbbreviation: 'BF',
    code2: '226'
  },
  {
    areaName: '巴林',
    checkKey: '^(00){0,1}(973){1}\\d{6,15}$',
    code: '973',
    domainAbbreviation: 'BH',
    code2: '973'
  },
  {
    areaName: '贝宁',
    checkKey: '^(00){0,1}(229){1}\\d{6,15}$',
    code: '229',
    domainAbbreviation: 'BJ',
    code2: '229'
  },
  {
    areaName: '文莱',
    checkKey: '^(00){0,1}(673){1}\\d{6,15}$',
    code: '673',
    domainAbbreviation: 'BN',
    code2: '673'
  },
  {
    areaName: '玻利维亚',
    checkKey: '^(00){0,1}(591){1}\\d{6,15}$',
    code: '591',
    domainAbbreviation: 'BO',
    code2: '591'
  },
  {
    areaName: '喀麦隆',
    checkKey: '^(00){0,1}(237){1}\\d{6,15}$',
    code: '237',
    domainAbbreviation: 'CM',
    code2: '237'
  },
  {
    areaName: '哥斯达黎加',
    checkKey: '^(00){0,1}(506){1}\\d{6,15}$',
    code: '506',
    domainAbbreviation: 'CR',
    code2: '506'
  },
  {
    areaName: '佛得角',
    checkKey: '^(00){0,1}(238){1}\\d{6,15}$',
    code: '238',
    domainAbbreviation: 'CV',
    code2: '238'
  },
  {
    areaName: '塞浦路斯',
    checkKey: '^(00){0,1}(357){1}\\d{6,15}$',
    code: '357',
    domainAbbreviation: 'CY',
    code2: '357'
  },
  {
    areaName: '吉布提',
    checkKey: '^(00){0,1}(253){1}\\d{6,15}$',
    code: '253',
    domainAbbreviation: 'DJ',
    code2: '253'
  },
  {
    areaName: '加蓬',
    checkKey: '^(00){0,1}(241){1}\\d{6,15}$',
    code: '241',
    domainAbbreviation: 'GA',
    code2: '241'
  },
  {
    areaName: '格林纳达',
    checkKey: '^(00){0,1}(1473){1}\\d{6,15}$',
    code: '1473',
    domainAbbreviation: 'GD',
    code2: '1473'
  },
  {
    areaName: '格鲁吉亚',
    checkKey: '^(00){0,1}(995){1}\\d{6,15}$',
    code: '995',
    domainAbbreviation: 'GE',
    code2: '995'
  },
  {
    areaName: '冈比亚',
    checkKey: '^(00){0,1}(220){1}\\d{6,15}$',
    code: '220',
    domainAbbreviation: 'GM',
    code2: '220'
  },
  {
    areaName: '几内亚',
    checkKey: '^(00){0,1}(224){1}\\d{6,15}$',
    code: '224',
    domainAbbreviation: 'GN',
    code2: '224'
  },
  {
    areaName: '赤道几内亚',
    checkKey: '^(00){0,1}(240){1}\\d{6,15}$',
    code: '240',
    domainAbbreviation: 'GQ',
    code2: '240'
  },
  {
    areaName: '危地马拉',
    checkKey: '^(00){0,1}(502){1}\\d{6,15}$',
    code: '502',
    domainAbbreviation: 'GT',
    code2: '502'
  },
  {
    areaName: '几内亚比绍',
    checkKey: '^(00){0,1}(245){1}\\d{6,15}$',
    code: '245',
    domainAbbreviation: 'GW',
    code2: '245'
  },
  {
    areaName: '圭亚那',
    checkKey: '^(00){0,1}(592){1}\\d{6,15}$',
    code: '592',
    domainAbbreviation: 'GY',
    code2: '592'
  },
  {
    areaName: '洪都拉斯',
    checkKey: '^(00){0,1}(504){1}\\d{6,15}$',
    code: '504',
    domainAbbreviation: 'HN',
    code2: '504'
  },
  {
    areaName: '克罗地亚',
    checkKey: '^(00){0,1}(385){1}\\d{6,15}$',
    code: '385',
    domainAbbreviation: 'HR',
    code2: '385'
  },
  {
    areaName: '牙买加',
    checkKey: '^(00){0,1}(1876){1}\\d{6,15}$',
    code: '1876',
    domainAbbreviation: 'JM',
    code2: '1876'
  },
  {
    areaName: '肯尼亚',
    checkKey: '^(00){0,1}(254){1}\\d{6,15}$',
    code: '254',
    domainAbbreviation: 'KE',
    code2: '254'
  },
  {
    areaName: '科摩罗',
    checkKey: '^(00){0,1}(269){1}\\d{6,15}$',
    code: '269',
    domainAbbreviation: 'KM',
    code2: '269'
  },
  {
    areaName: '科威特',
    checkKey: '^(00){0,1}(965){1}\\d{6,15}$',
    code: '965',
    domainAbbreviation: 'KW',
    code2: '965'
  },
  {
    areaName: '开曼群岛',
    checkKey: '^(00){0,1}(1345){1}\\d{6,15}$',
    code: '1345',
    domainAbbreviation: 'KY',
    code2: '1345'
  },
  {
    areaName: '莱索托',
    checkKey: '^(00){0,1}(266){1}\\d{6,15}$',
    code: '266',
    domainAbbreviation: 'LS',
    code2: '266'
  },
  {
    areaName: '拉脱维亚',
    checkKey: '^(00){0,1}(371){1}\\d{6,15}$',
    code: '371',
    domainAbbreviation: 'LV',
    code2: '371'
  },
  {
    areaName: '摩尔多瓦',
    checkKey: '^(00){0,1}(373){1}\\d{6,15}$',
    code: '373',
    domainAbbreviation: 'MD',
    code2: '373'
  },
  {
    areaName: '马达加斯加',
    checkKey: '^(00){0,1}(261){1}\\d{6,15}$',
    code: '261',
    domainAbbreviation: 'MG',
    code2: '261'
  },
  {
    areaName: '马里',
    checkKey: '^(00){0,1}(223){1}\\d{6,15}$',
    code: '223',
    domainAbbreviation: 'ML',
    code2: '223'
  },
  {
    areaName: '毛里塔尼亚',
    checkKey: '^(00){0,1}(222){1}\\d{6,15}$',
    code: '222',
    domainAbbreviation: 'MR',
    code2: '222'
  },
  {
    areaName: '毛里求斯',
    checkKey: '^(00){0,1}(230){1}\\d{6,15}$',
    code: '230',
    domainAbbreviation: 'MU',
    code2: '230'
  },
  {
    areaName: '马拉维',
    checkKey: '^(00){0,1}(265){1}\\d{6,15}$',
    code: '265',
    domainAbbreviation: 'MW',
    code2: '265'
  },
  {
    areaName: '莫桑比克',
    checkKey: '^(00){0,1}(258){1}\\d{6,15}$',
    code: '258',
    domainAbbreviation: 'MZ',
    code2: '258'
  },
  {
    areaName: '纳米比亚',
    checkKey: '^(00){0,1}(264){1}\\d{6,15}$',
    code: '264',
    domainAbbreviation: 'NA',
    code2: '264'
  },
  {
    areaName: '尼日尔',
    checkKey: '^(00){0,1}(227){1}\\d{6,15}$',
    code: '227',
    domainAbbreviation: 'NE',
    code2: '227'
  },
  {
    areaName: '尼加拉瓜',
    checkKey: '^(00){0,1}(505){1}\\d{6,15}$',
    code: '505',
    domainAbbreviation: 'NI',
    code2: '505'
  },
  {
    areaName: '阿曼',
    checkKey: '^(00){0,1}(968){1}\\d{6,15}$',
    code: '968',
    domainAbbreviation: 'OM',
    code2: '968'
  },
  {
    areaName: '巴布亚新几内亚',
    checkKey: '^(00){0,1}(675){1}\\d{6,15}$',
    code: '675',
    domainAbbreviation: 'PG',
    code2: '675'
  },
  {
    areaName: '巴勒斯坦',
    checkKey: '^(00){0,1}(970){1}\\d{6,15}$',
    code: '970',
    domainAbbreviation: 'PS',
    code2: '970'
  },
  {
    areaName: '卢旺达',
    checkKey: '^(00){0,1}(250){1}\\d{6,15}$',
    code: '250',
    domainAbbreviation: 'RW',
    code2: '250'
  },
  {
    areaName: '斯洛文尼亚',
    checkKey: '^(00){0,1}(386){1}\\d{6,15}$',
    code: '386',
    domainAbbreviation: 'SI',
    code2: '386'
  },
  {
    areaName: '斯洛伐克',
    checkKey: '^(00){0,1}(421){1}\\d{6,15}$',
    code: '421',
    domainAbbreviation: 'SK',
    code2: '421'
  },
  {
    areaName: '塞拉利昂',
    checkKey: '^(00){0,1}(232){1}\\d{6,15}$',
    code: '232',
    domainAbbreviation: 'SL',
    code2: '232'
  },
  {
    areaName: '塞内加尔',
    checkKey: '^(00){0,1}(221){1}\\d{6,15}$',
    code: '221',
    domainAbbreviation: 'SN',
    code2: '221'
  },
  {
    areaName: '苏里南',
    checkKey: '^(00){0,1}(597){1}\\d{6,15}$',
    code: '597',
    domainAbbreviation: 'SR',
    code2: '597'
  },
  {
    areaName: '萨尔瓦多',
    checkKey: '^(00){0,1}(503){1}\\d{6,15}$',
    code: '503',
    domainAbbreviation: 'SV',
    code2: '503'
  },
  {
    areaName: '斯威士兰',
    checkKey: '^(00){0,1}(268){1}\\d{6,15}$',
    code: '268',
    domainAbbreviation: 'SZ',
    code2: '268'
  },
  {
    areaName: '乍得',
    checkKey: '^(00){0,1}(235){1}\\d{6,15}$',
    code: '235',
    domainAbbreviation: 'TD',
    code2: '235'
  },
  {
    areaName: '多哥',
    checkKey: '^(00){0,1}(228){1}\\d{6,15}$',
    code: '228',
    domainAbbreviation: 'TG',
    code2: '228'
  },
  {
    areaName: '塔吉克斯坦',
    checkKey: '^(00){0,1}(992){1}\\d{6,15}$',
    code: '992',
    domainAbbreviation: 'TJ',
    code2: '992'
  },
  {
    areaName: '土库曼斯坦',
    checkKey: '^(00){0,1}(993){1}\\d{6,15}$',
    code: '993',
    domainAbbreviation: 'TM',
    code2: '993'
  },
  {
    areaName: '特立尼达和多巴哥',
    checkKey: '^(00){0,1}(1868){1}\\d{6,15}$',
    code: '1868',
    domainAbbreviation: 'TT',
    code2: '1868'
  },
  {
    areaName: '坦桑尼亚',
    checkKey: '^(00){0,1}(255){1}\\d{6,15}$',
    code: '255',
    domainAbbreviation: 'TZ',
    code2: '255'
  },
  {
    areaName: '乌干达',
    checkKey: '^(00){0,1}(256){1}\\d{6,15}$',
    code: '256',
    domainAbbreviation: 'UG',
    code2: '256'
  },
  {
    areaName: '乌拉圭',
    checkKey: '^(00){0,1}(598){1}\\d{6,15}$',
    code: '598',
    domainAbbreviation: 'UY',
    code2: '598'
  },
  {
    areaName: '乌兹别克斯坦',
    checkKey: '^(00){0,1}(998){1}\\d{6,15}$',
    code: '998',
    domainAbbreviation: 'UZ',
    code2: '998'
  },
  {
    areaName: '也门',
    checkKey: '^(00){0,1}(967){1}\\d{6,15}$',
    code: '967',
    domainAbbreviation: 'YE',
    code2: '967'
  },
  {
    areaName: '赞比亚',
    checkKey: '^(00){0,1}(260){1}\\d{6,15}$',
    code: '260',
    domainAbbreviation: 'ZM',
    code2: '260'
  },
  {
    areaName: '津巴布韦',
    checkKey: '^(00){0,1}(263){1}\\d{6,15}$',
    code: '263',
    domainAbbreviation: 'ZW',
    code2: '263'
  },
  {
    areaName: '安道尔共和国',
    checkKey: '^(00){0,1}(376){1}\\d{6,15}$',
    code: '376',
    domainAbbreviation: 'AD',
    code2: '376'
  },
  {
    areaName: '阿富汗',
    checkKey: '^(00){0,1}(93){1}\\d{6,15}$',
    code: '93',
    domainAbbreviation: 'AF',
    code2: '93'
  },
  {
    areaName: '亚美尼亚',
    checkKey: '^(00){0,1}(374){1}\\d{6,15}$',
    code: '374',
    domainAbbreviation: 'AM',
    code2: '374'
  },
  {
    areaName: '波斯尼亚和黑塞哥维那',
    checkKey: '^(00){0,1}(387){1}\\d{6,15}$',
    code: '387',
    domainAbbreviation: 'BA',
    code2: '387'
  },
  {
    areaName: '孟加拉国',
    checkKey: '^(00){0,1}(880){1}\\d{6,15}$',
    code: '880',
    domainAbbreviation: 'BD',
    code2: '880'
  },
  {
    areaName: '布隆迪',
    checkKey: '^(00){0,1}(257){1}\\d{6,15}$',
    code: '257',
    domainAbbreviation: 'BI',
    code2: '257'
  },
  {
    areaName: '博茨瓦纳',
    checkKey: '^(00){0,1}(267){1}\\d{6,15}$',
    code: '267',
    domainAbbreviation: 'BW',
    code2: '267'
  },
  {
    areaName: '刚果(金)',
    checkKey: '^(00){0,1}(243){1}\\d{6,15}$',
    code: '243',
    domainAbbreviation: 'CD',
    code2: '243'
  },
  {
    areaName: '中非',
    checkKey: '^(00){0,1}(236){1}\\d{6,15}$',
    code: '236',
    domainAbbreviation: 'CF',
    code2: '236'
  },
  {
    areaName: '刚果(布)',
    checkKey: '^(00){0,1}(242){1}\\d{6,15}$',
    code: '242',
    domainAbbreviation: 'CG',
    code2: '242'
  },
  {
    areaName: '科特迪瓦',
    checkKey: '^(00){0,1}(225){1}\\d{6,15}$',
    code: '225',
    domainAbbreviation: 'CI',
    code2: '225'
  },
  {
    areaName: '库拉索岛',
    checkKey: '^(00){0,1}(599){1}\\d{6,15}$',
    code: '599',
    domainAbbreviation: 'CW',
    code2: '599'
  },
  {
    areaName: '多米尼加共和国',
    checkKey: '^(00){0,1}(1809){1}\\d{6,15}$',
    code: '1809',
    domainAbbreviation: 'DO',
    code2: '1809'
  },
  {
    areaName: '捷克共和国',
    checkKey: '^(00){0,1}(420){1}\\d{6,15}$',
    code: '420',
    domainAbbreviation: 'CZ',
    code2: '420'
  },
  {
    areaName: '阿尔及利亚',
    checkKey: '^(00){0,1}(213){1}\\d{6,15}$',
    code: '213',
    domainAbbreviation: 'DZ',
    code2: '213'
  },
  {
    areaName: '厄瓜多尔',
    checkKey: '^(00){0,1}(593){1}\\d{6,15}$',
    code: '593',
    domainAbbreviation: 'EC',
    code2: '593'
  },
  {
    areaName: '加纳',
    checkKey: '^(00){0,1}(233){1}\\d{6,15}$',
    code: '233',
    domainAbbreviation: 'GH',
    code2: '233'
  },
  {
    areaName: '伊拉克',
    checkKey: '^(00){0,1}(964){1}\\d{6,15}$',
    code: '964',
    domainAbbreviation: 'IQ',
    code2: '964'
  },
  {
    areaName: '哈萨克斯坦',
    checkKey: '^(00){0,1}(7){1}\\d{6,15}$',
    code: '7',
    domainAbbreviation: 'KZ',
    code2: 'KZ'
  },
  {
    areaName: '老挝',
    checkKey: '^(00){0,1}(856){1}\\d{6,15}$',
    code: '856',
    domainAbbreviation: 'LA',
    code2: '856'
  },
  {
    areaName: '黎巴嫩',
    checkKey: '^(00){0,1}(961){1}\\d{6,15}$',
    code: '961',
    domainAbbreviation: 'LB',
    code2: '961'
  },
  {
    areaName: '利比里亚',
    checkKey: '^(00){0,1}(231){1}\\d{6,15}$',
    code: '231',
    domainAbbreviation: 'LR',
    code2: '231'
  },
  {
    areaName: '利比亚',
    checkKey: '^(00){0,1}(218){1}\\d{6,15}$',
    code: '218',
    domainAbbreviation: 'LY',
    code2: '218'
  },
  {
    areaName: '黑山共和国',
    checkKey: '^(00){0,1}(382){1}\\d{6,15}$',
    code: '382',
    domainAbbreviation: 'ME',
    code2: '382'
  },
  {
    areaName: '圣马丁',
    checkKey: '^(00){0,1}(590){1}\\d{6,15}$',
    code: '590',
    domainAbbreviation: 'MF',
    code2: '590'
  },
  {
    areaName: '马其顿',
    checkKey: '^(00){0,1}(389){1}\\d{6,15}$',
    code: '389',
    domainAbbreviation: 'MK',
    code2: '389'
  },
  {
    areaName: '缅甸',
    checkKey: '^(00){0,1}(95){1}\\d{6,15}$',
    code: '95',
    domainAbbreviation: 'MM',
    code2: '95'
  },
  {
    areaName: '巴基斯坦',
    checkKey: '^(00){0,1}(92){1}\\d{6,15}$',
    code: '92',
    domainAbbreviation: 'PK',
    code2: '92'
  },
  {
    areaName: '波多黎各',
    checkKey: '^(00){0,1}(1787){1}\\d{6,15}$',
    code: '1787',
    domainAbbreviation: 'PR',
    code2: '1787'
  },
  {
    areaName: '索马里',
    checkKey: '^(00){0,1}(252){1}\\d{6,15}$',
    code: '252',
    domainAbbreviation: 'SO',
    code2: '252'
  },
  {
    areaName: '圣文森特和格林纳丁斯',
    checkKey: '^(00){0,1}(1784){1}\\d{6,15}$',
    code: '1784',
    domainAbbreviation: 'VC',
    code2: '1784'
  },
  {
    areaName: '科索沃',
    checkKey: '^(00){0,1}(383){1}\\d{6,15}$',
    code: '383',
    domainAbbreviation: 'XK',
    code2: '383'
  },
  {
    areaName: '尼泊尔',
    checkKey: '^(00){0,1}(977){1}\\d{6,15}$',
    code: '977',
    domainAbbreviation: 'NP',
    code2: '977'
  },
  {
    areaName: '马耳他',
    checkKey: '^(00){0,1}(356){1}\\d{6,15}$',
    code: '356',
    domainAbbreviation: 'MT',
    code2: '356'
  }
];

export const SystemWxAppIdMap = {
  JCH: 'wxa16d7844b1d57b5a'
};

export const FileTypeMap = {
  IMAGE: 1,
  VIDEO: 2
};

export const sendMsgParams = '2235478855ghuudffhhjn5555';
export const sendMsgParamsUat = 'x9Kp2mNq8RzLwEjYvSbHtGcA1oPfIu7d';
export const decryptParams = '8uidjuifoiju87654wgydshuiomxnhsd';
export const orderParams = '36GdjfIOycetEkZftDsp9aUY2WFUuiK5';
export const xverseParams = '23FD65849CA1DECEDB6F84AA627FA072'; // 元宇宙
export const appSecret_FN = '7E4FD1A68C9B234510F867C2D9AB483E'; // 蜂鸟
export const appSecret_YX = 'CF2CB9873DA748099FB9D4D58F65963D'; // login
export const appSecret_HLW = '3B2AC8364A5B375042B145C3E8ED2592'; // HLW xbl20240722
export const appSecret_GCC = 'E0D511356BD44120AF49CC96C9DCF3B3'; // gcc

// 培训中底部菜单
export const learningMenuMap = {
  1: '/learn/finding',
  2: '/learn/college',
  3: '/learn/tools/ToolsView',
  4: '/learn/my',
  5: '/learn/information'
};

export const descriptionList = ['#复消专区#', '#升级恭贺礼#', '#会员续约礼#'];

// 推客类小程序原始 id
export const ghObj = {
  ld: 'gh_542025bff596',
  ls: 'gh_9966ef3ea349',
  hy: 'gh_9966ef3ea349'
};

// 蜂鸟小程序
export const fenNiaoGhId = 'gh_62517e9b6920';

// 蜂鸟小程序logo
export const fenNiaoLogoImg = 'https://image.yofogo.com/images/common/link_to_common_fenniao.png';

export const internationalFreightTypeMap = {
  DIRECTLY_SUPPLEMENT: 1, // 直接补
  FREE_SHIPPING: 2 // 享包邮
};

export const systemTypeMap = {
  NEW: 1, // 新零售体系
  SS: 0 // 三生体系
};

/**
 * 根据 areaCode 获取国家代码 (domainAbbreviation)
 * @param {string|Array} areaCode 地区代码，支持字符串或数组（数组则取第一个元素）
 * @returns {object} 对应的国家代码和区号
 */
export const getDomainCodeByAreaCode = (areaCode) => {
  if (!areaCode) return { code: '', domainAbbreviation: '' };

  const code = Array.isArray(areaCode) ? areaCode[0] : areaCode;
  const country = countryList.find(
    (item) => item.code2 === String(code) || item.code === String(code)
  );
  return {
    code: (country && country.code) || '',
    domainAbbreviation: (country && country.domainAbbreviation) || ''
  };
};

// 商城类型枚举
export const MallType = {
  RETAIL: 4, // 零售
  CONSUME: 5, // 消费
  SALE: 6 // 销售
};
/**
 * 三区类型枚举，兼容早期的globalSaleMode
 * globalSaleMode: 2, // 销售
 * globalSaleMode: 3, // 消费
 */
export const SaleModeType = {
  RETAIL: 3, // 零售（早期的消费）
  SALE: 2 // 销售
};

// 卡类型枚举
export const CardType = {
  DISCOUNT_CUSTOMER: -1, // 优惠顾客
  NORMAL: 0, // 普卡
  SILVER: 1, // 银卡
  GOLD: 2, // 金卡
  DIAMOND: 3, // 钻卡
  DIAMOND_1: 4, // 钻1
  DIAMOND_2: 5, // 钻2
  DIAMOND_3: 6 // 钻3
};



// WEBPACK FOOTER //
// ./src/utils/constants.js